<template>
    <div class="main">
        <el-dialog
            :title="openData.title"
            :visible.sync="openData.state"
            :close-on-click-modal="false"
            width="700px"
            class="dialog_container"
            @close="dialogVisibleClone"
        >
            <div class="dialog_content">
                <el-form
                    :disabled="openData.title == '详情'"
                    label-position="left"
                    label-width="130px"
                    ref="formData"
                    :model="formData"
                    :rules="formDataRules"
                >
                    <el-form-item label="培训主题：" prop="serviceTitle">
                        <el-input
                            disabled
                            v-model.trim="formData.serviceTitle"
                            placeholder="请输入培训主题"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="主讲人：" prop="serviceTitle">
                        <el-input
                            disabled
                            v-model.trim="formData.serviceTitle"
                            placeholder="请输入主讲人"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="培训地点：" prop="serviceTitle">
                        <el-input
                            disabled
                            v-model.trim="formData.serviceTitle"
                            placeholder="请输入地点"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="培训技能：" prop="serviceTitle">
                        <el-input
                            disabled
                            v-model.trim="formData.serviceTitle"
                            placeholder="请输入技能"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="培训内容：">
                        <quillEditor
                            style="width: 100%"
                            :disabled="title == '查看' ? 'readonly' : ''"
                            v-model="formData.taskContent"
                        >
                        </quillEditor>
                    </el-form-item>
                    <el-form-item label="参与情况：" prop="serviceTitle">
                        <el-input
                            type="textarea"
                            :autosize="{ minRows: 2 }"
                            v-model.trim="formData.serviceTitle"
                            placeholder="请输入参与情况"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="表现情况：" prop="serviceTitle">
                        <el-input
                            type="textarea"
                            :autosize="{ minRows: 2 }"
                            v-model.trim="formData.serviceTitle"
                            placeholder="请输入表现情况"
                        ></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div
                slot="footer"
                class="dialog-footer dialog-footer-btn"
                v-if="openData.title != '详情'"
            >
                <el-button type="primary" @click="handleSubmit"
                    >确 定</el-button
                >
                <el-button @click="dialogVisibleClone">取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import baseURL from "@/api/baseURL"
import "quill/dist/quill.core.css"
import "quill/dist/quill.snow.css"
import "quill/dist/quill.bubble.css"
import { quillEditor } from "vue-quill-editor"
export default {
    props: ["openData"],
    components: {
        quillEditor,
    },
    data() {
        return {
            formData: {},
            formDataRules: {},
            orgList: [
                { value: "0", label: "民法典" },
                { value: "1", label: "网格化服务管理中心管理制度" },
                { value: "2", label: "物业管理条例" },
            ],
        }
    },
    created() {},
    methods: {
        handleSubmit() {
            this.$emit("cancleAddress", true)
        },
        dialogVisibleClone() {
            this.$emit("cancleAddress", false)
        },
    },
}
</script>
<style lang="less" scoped>
</style>